import React from 'react';
import cx from 'classnames';
export const DescriptionList = ({ className, items, includeTitle = true, autofill, loading = false, }) => (React.createElement("div", { className: cx(className, 'description-list', { 'description-list--autofill': autofill }) }, items.map(({ title, description, isPrimary = true }, index) => (React.createElement("div", { key: index, className: cx('description-list_item', title !== undefined &&
        title &&
        title
            .toLowerCase()
            .trim()
            .replace(' ', '-')) },
    includeTitle && (React.createElement("div", { className: cx('description-list_title', {
            'description-list_title--loading': loading,
        }) }, loading ? '' : title)),
    React.createElement("div", { className: cx('description-list_description', {
            'description-list_description--loading': loading,
        }) }, loading ? '' : description ? description : `—`))))));
//# sourceMappingURL=DescriptionList.js.map